import { makeStyles } from '@material-ui/core';
import React, { useContext, useEffect } from 'react';
import loginImg from '../../assets/images/sign-up-login.png';
import LoginForm from '../../components/LoginForm';
import MessagesContext from '../../contexts/messagesContext';
import { useIndexedDB } from 'react-indexed-db';
import { delAllSelectedPatients } from '../../redux/Patient/PatientAction';
import { useDispatch } from 'react-redux';

const styles = makeStyles((theme) => ({
    loginWrapper: {
        background: '#006699',
        height: '100vh',
        overflow: 'auto',
        position: 'relative',
        display: 'flex',
        [theme.breakpoints.down(970)]: {
            background: '#fff'
        }
    },
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%'
    },
    row: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '1000px',
        width: '100%',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gridGap: '40px',
        justifyContent: 'space-between',
        background: '#fff',
        borderRadius: '10px',
        padding: '45px 67px',
        [theme.breakpoints.down(1070)]: {
            maxWidth: '900px'
        },
        [theme.breakpoints.down(970)]: {
            padding: '40px 24px',
            gridTemplateColumns: '1fr',
            gridGap: '20px',
            maxWidth: '800px'
        },
        [theme.breakpoints.down(850)]: {
            maxWidth: '700px'
        },
        [theme.breakpoints.down(850)]: {
            maxWidth: '600px'
        },
        [theme.breakpoints.down(670)]: {
            maxWidth: '500px'
        },
        [theme.breakpoints.down(550)]: {
            maxWidth: '400px'
        },
        [theme.breakpoints.down(450)]: {
            maxWidth: '310px'
        }
    },
    col1: {
        [theme.breakpoints.down(970)]: {
            display: 'none'
        }
    },

    welcomeMessage: {
        fontFamily: 'inherit',
        fontSize: '16px',
        fontWeight: 'bold',
        textAlign: 'right',
        color: '#3d454a',
        lineHeight: 2
    }
}));

const Login = () => {
    const classes = styles();
    const { messages } = useContext(MessagesContext);
    const { clear } = useIndexedDB('patients');
    const dispatch = useDispatch();

    useEffect(() => {
        clear();
        dispatch(delAllSelectedPatients());
    }, []);
    return (
        <>
            <div className={classes.loginWrapper}>
                <div className={classes.container}>
                    <div className={classes.row}>
                        <div className={classes.col1}>
                            {/* <img src={logo} alt="logo" /> */}
                            <h5 className={classes.welcomeMessage}>
                                {messages.login.welcomeMessage}
                            </h5>
                            <img src={loginImg} alt="backgroundImg" />
                        </div>
                        <div className={classes.col2}>
                            <LoginForm />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Login;
